import { xchacha20poly1305 } from "@noble/ciphers/chacha.js";
import { randomBytes } from "@noble/hashes/utils.js";

const NONCE_LENGTH = 24;

export function encrypt(
  key: Uint8Array,
  plaintext: Uint8Array,
  nonce?: Uint8Array,
): { ciphertext: Uint8Array; nonce: Uint8Array } {
  const usedNonce = nonce ?? randomBytes(NONCE_LENGTH);
  const cipher = xchacha20poly1305(key, usedNonce);
  return { ciphertext: cipher.encrypt(plaintext), nonce: usedNonce };
}

export function decrypt(
  key: Uint8Array,
  ciphertext: Uint8Array,
  nonce: Uint8Array,
): Uint8Array {
  const cipher = xchacha20poly1305(key, nonce);
  return cipher.decrypt(ciphertext);
}

export { NONCE_LENGTH as XCHACHA_NONCE_LENGTH };
